import { render, staticRenderFns } from "./StockyDataMigration.vue?vue&type=template&id=9cea2e8a&scoped=true"
import script from "./StockyDataMigration.vue?vue&type=script&lang=ts"
export * from "./StockyDataMigration.vue?vue&type=script&lang=ts"
import style0 from "./StockyDataMigration.vue?vue&type=style&index=0&id=9cea2e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cea2e8a",
  null
  
)

export default component.exports